// Import all actions
import * as actions from "../actions/langActions";

export const initialState = {
  supported_languages: [
    { name: "English", code: "en" },
    { name: "Srpski", code: "sr" },
    { name: "Deutch", code: "de" },
    { name: "Italiano", code: "it" },
    { name: "Русский", code: "ru" },
  ],
  language: "en", // active
};

export default function langReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_LANGUAGE:
      return { ...state, language: action.payload };
    default:
      return state;
  }
}
